import React, { useState, useEffect } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faMapMarkerAlt, 
  faClock, 
  faEye, 
  faSearch, 
  faFilePdf,
  faCheckCircle,
  faCheck,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import { faStar as farStar } from '@fortawesome/free-regular-svg-icons';
import { faStar as fasStar } from '@fortawesome/free-solid-svg-icons';
import Footer from "./Footer";
import Navbar from "./Navbar";
import { jsPDF } from 'jspdf';
// import logo from '../../assets/logo.png'; // Make sure to have your logo in the correct path
import logo1 from '../../assets/image1.jpg'; // Make sure to have your logo in the correct path

const TourDetailsModal = ({ tour, onClose }) => {
  const generatePDF = async () => {
    if (!tour) return;

    try {
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4"
      });

      let yPosition = 10;

      // Add logo
      const img = new Image();
      img.src = logo1;
      await new Promise(resolve => img.onload = resolve);

      const logoWidth = 200;
      const logoHeight = 100;
      const centerX = 105 - logoWidth / 2;
      doc.addImage(img, 'PNG', centerX, yPosition, logoWidth, logoHeight);
      yPosition += logoHeight + 5;

      // Add company info
      
      // Add package name
      doc.setFontSize(18);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text(`${tour.name.toUpperCase()}`, 20, yPosition);
      yPosition += 10;

      // Add package details
      doc.setFontSize(12);
      doc.setTextColor(80, 80, 80);
      doc.setFont("helvetica", "normal");
      doc.text(`Destination: ${tour.destination}`, 20, yPosition);
      yPosition += 7;
      doc.text(`Duration: ${tour.duration}`, 20, yPosition);
      yPosition += 7;




      // ✅ Add package details
// doc.setFontSize(12);
// doc.setTextColor(80, 80, 80);
// doc.setFont("helvetica", "normal");
// doc.text(`Destination: ${tour.destination}`, 20, yPosition);
// yPosition += 7;
// doc.text(`Duration: ${tour.duration}`, 20, yPosition);
// yPosition += 7;

// ======================
// ✅ UPDATED PRICE SECTION
// ======================
doc.setFontSize(12);
doc.setTextColor(30, 58, 138);
doc.setFont("helvetica", "bold");
doc.text("PRICE DETAILS", 20, yPosition);
yPosition += 7;

doc.setFontSize(12);
doc.setFont("helvetica", "normal");

const extractNumbers = (str) => {
  if (typeof str === "number") return str;
  const numMatch = str?.toString().match(/\d+(\.\d+)?/g);
  if (numMatch) {
    const numStr = numMatch[0].replace(/,/g, "");
    return parseFloat(numStr);
  }
  return 0;
};

if (
  tour.priceValues &&
  typeof tour.priceValues === "object" &&
  Object.keys(tour.priceValues).length > 0
) {
  doc.setFillColor(241, 243, 245);
  doc.rect(15, yPosition, 180, 8, "F");

  doc.setFontSize(10);
  doc.setTextColor(30, 58, 138);
  doc.text("Price Breakdown", 20, yPosition + 6);
  yPosition += 15;

  Object.entries(tour.priceValues).forEach(([priceType, priceValue]) => {
    // Display the original price without any modifications
    const displayText = priceValue;

    doc.setTextColor(30, 58, 138);
    doc.text(displayText, 20, yPosition);

    yPosition += 10;
    if (yPosition > 267) {
      doc.addPage();
      yPosition = 20;
    }
  });

  if (tour.totalPrice) {
    doc.setFont("helvetica", "bold");
    doc.text(`Total Package Price: ${tour.totalPrice}`, 20, yPosition);

    const totalNumeric = extractNumbers(tour.totalPrice);
    const discountedTotal = Math.max(0, totalNumeric - 2000);
    const formattedDiscountedTotal = `₹${discountedTotal.toLocaleString("en-IN")}`;

    doc.setTextColor(30, 58, 138);
    doc.text(`Discounted Total: ${formattedDiscountedTotal}`, 20, yPosition + 8);

    yPosition += 16;
  }
} else if (tour.discountedPrice) {
  doc.text(`Price: ₹${tour.originalPrice?.toLocaleString("en-IN")}`, 20, yPosition);

  const discountedPrice = Math.max(0, tour.originalPrice - 2000);
  const formattedDiscountedPrice = `₹${discountedPrice.toLocaleString("en-IN")}`;

  doc.setTextColor(30, 58, 138);
  doc.text(`Discounted Price: ${formattedDiscountedPrice}`, 20, yPosition + 8);

  yPosition += 16;
} else {
  doc.text("No pricing information available", 20, yPosition);
  yPosition += 7;
}

yPosition += 10;





      // Add description
      doc.setFontSize(14);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("DESCRIPTION", 20, yPosition);
      yPosition += 10;

      doc.setFontSize(12);
      doc.setTextColor(50, 50, 50);
      const descriptionLines = doc.splitTextToSize(tour.description || "No description available", 170);
      descriptionLines.forEach(line => {
        if (yPosition > 267) {
          doc.addPage();
          yPosition = 20;
        }
        doc.text(line, 20, yPosition);
        yPosition += 6;
      });
      yPosition += 10;

      // Add itinerary
      doc.addPage();
      yPosition = 20;
      doc.setFontSize(16);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("DETAILED ITINERARY", 105, yPosition, { align: "center" });
      yPosition += 10;

      if (tour.itinerary && typeof tour.itinerary === "object") {
        Object.entries(tour.itinerary).forEach(([dayTitle, description], index) => {
          if (yPosition > 267) {
            doc.addPage();
            yPosition = 20;
          }

          doc.setFillColor(241, 243, 245);
          doc.rect(15, yPosition, 180, 8, 'F');
          doc.setFontSize(14);
          doc.setTextColor(30, 58, 138);
          doc.text(dayTitle, 20, yPosition + 6);
          yPosition += 10;

          yPosition += 5;

          doc.setFontSize(12);
          doc.setTextColor(50, 50, 50);
          const descLines = doc.splitTextToSize(description, 170);
          descLines.forEach(line => {
            if (yPosition > 267) {
              doc.addPage();
              yPosition = 20;
            }
            doc.text(line, 20, yPosition);
            yPosition += 6;
          });
          yPosition += 5;
        });
      } else {
        doc.text("No detailed itinerary available.", 20, yPosition);
        yPosition += 10;
      }

      // Add inclusions
      doc.addPage();
      yPosition = 20;
      doc.setFontSize(16);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("INCLUSIONS", 20, yPosition);
      yPosition += 10;

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      if (tour.includes && typeof tour.includes === 'object') {
        Object.values(tour.includes).forEach((item) => {
          if (yPosition > 267) {
            doc.addPage();
            yPosition = 20;
          }
          doc.text(`• ${item}`, 25, yPosition);
          yPosition += 7;
        });
      } else {
        doc.text("No inclusions listed.", 25, yPosition);
        yPosition += 7;
      }

      // Add exclusions
      yPosition += 10;
      doc.setFontSize(16);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("EXCLUSIONS", 20, yPosition);
      yPosition += 10;

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      if (tour.excludes && typeof tour.excludes === 'object') {
        Object.values(tour.excludes).forEach((item) => {
          if (yPosition > 267) {
            doc.addPage();
            yPosition = 20;
          }
          doc.text(`• ${item}`, 25, yPosition);
          yPosition += 7;
        });
      } else {
        doc.text("No exclusions listed.", 25, yPosition);
        yPosition += 7;
      }

      // Add footer to all pages
      const pageCount = doc.internal.getNumberOfPages();
      const footerY = 287;
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setDrawColor(200, 200, 200);
        doc.setLineWidth(0.3);
        doc.line(15, footerY - 5, 195, footerY - 5);
        doc.setFontSize(10);
        doc.setTextColor(100, 100, 100);
        doc.text(`Page ${i} of ${pageCount}`, 105, footerY, { align: "center" });
        doc.text("Pearl Tours & Travels", 20, footerY);
        doc.text(new Date().toLocaleDateString(), 190, footerY, { align: "right" });
      }

      // Save the PDF
      const fileName = `${(tour.name || 'tour').replace(/\s+/g, '_')}_package_details.pdf`;
      doc.save(fileName);
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  if (!tour) return null;

  return (
    <div className="modal-overlay" onClick={(e) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    }}>
      <div className="modal-container">
        <button className="modal-close-btn" onClick={onClose}>
          &times;
        </button>
        
        <div className="modal-header">
          <h2>{tour.name}</h2>
          <div className="modal-subheader">
            <span className="modal-location">
              <FontAwesomeIcon icon={faMapMarkerAlt} /> {tour.destination}
            </span>
            <span className="modal-duration">
              <FontAwesomeIcon icon={faClock} /> {tour.duration}
            </span>
            <span className="modal-rating">
              {[...Array(5)].map((_, i) => (
                <FontAwesomeIcon 
                  key={i} 
                  icon={i < Math.floor(tour.rating || 5) ? fasStar : farStar} 
                  className={i < (tour.rating || 5) ? 'filled' : ''}
                />
              ))}
              ({tour.rating || 5}.0)
            </span>
          </div>
        </div>
        
        <div className="modal-image-gallery">
          <div className="main-image">
            <img 
              src={tour.images?.[0] || "https://via.placeholder.com/800x500?text=No+Image"} 
              alt={tour.name} 
            />
          </div>
          <div className="thumbnail-container">
            {(tour.images || []).slice(0, 4).map((img, index) => (
              <div key={index} className="thumbnail">
                <img src={img} alt={`${tour.name} ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
        
        <div className="modal-content">
          <div className="modal-price-section">
            <div className="price-box">
              <span className="itinerary">Description : <br/>{tour.description}</span>
              {/* <span className="price-label">Starting from</span>
              <span className="price-amount">₹{tour.discountedPrice?.toLocaleString() || "0"}</span> */}
              {/* <span className="price-per">per person</span> */}
              <button 
                className="pdf-download-btn"
                onClick={generatePDF}
              >
                <FontAwesomeIcon icon={faFilePdf} /> Download PDF
              </button>
            </div>
          </div>
          
          <div className="modal-details-section">
            <h3>Package Highlights</h3>
            <ul className="highlights-list">
              {(tour.highlights || []).map((item, index) => (
                <li key={index}>
                  <FontAwesomeIcon icon={faCheckCircle} className="highlight-icon" /> {item}
                </li>
              ))}
            </ul>
            
            <h3>Detailed Itinerary</h3>
            <div className="itinerary">
              {tour.itinerary && typeof tour.itinerary === "object" ? (
                Object.entries(tour.itinerary).map(([dayTitle, description], index) => (
                  <div key={index} className="day-plan">
                    <h4>{dayTitle}</h4>
                    <p>{description}</p>
                  </div>
                ))
              ) : (
                <p>No detailed itinerary available.</p>
              )}
            </div>

            <h3>Inclusions</h3>
            <ul className="inclusions-list">
              {tour.includes && typeof tour.includes === 'object' ? (
                Object.values(tour.includes).map((item, index) => (
                  <li key={index}>
                    <FontAwesomeIcon icon={faCheck} className="inclusion-icon" /> {item}
                  </li>
                ))
              ) : (
                <li>No inclusions listed.</li>
              )}
            </ul>

            <h3>Exclusions</h3>
            <ul className="exclusions-list">
              {tour.excludes && typeof tour.excludes === 'object' ? (
                Object.values(tour.excludes).map((item, index) => (
                  <li key={index}>
                    <FontAwesomeIcon icon={faTimes} className="exclusion-icon" /> {item}
                  </li>
                ))
              ) : (
                <li>No exclusions listed.</li>
              )}
            </ul>

            {tour.termsAndConditions && (
              <>
                <h3>Terms & Conditions</h3>
                <p className="terms">{tour.termsAndConditions}</p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default function InternationalTourPackages() {
  const [allPackages, setAllPackages] = useState([]);
  const [filteredPackages, setFilteredPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTour, setSelectedTour] = useState(null);
  const [visibleCount, setVisibleCount] = useState(6);
  const [searchQuery, setSearchQuery] = useState("");

  // useEffect(() => {
  //   const database = getDatabase();
  //   const packagesRef = ref(database, "AgentPackages/international");

  //   const unsubscribe = onValue(packagesRef, (snapshot) => {
  //     const data = snapshot.val();
  //     const packagesArray = [];

  //     if (data) {
  //       Object.keys(data).forEach((country) => {
  //         Object.keys(data[country]).forEach((packageName) => {
  //           const pkg = data[country][packageName];

  //           if (pkg.type === "international") {
  //             const originalPrice = pkg.price || 0;
  //             const discountedPrice = originalPrice - 0;

  //             packagesArray.push({
  //               id: `${country}-${packageName}`,
  //               ...pkg,
  //               originalPrice,
  //               discountedPrice,
  //             });
  //           }
  //         });
  //       });
  //     }

  //     setAllPackages(packagesArray);
  //     setFilteredPackages(packagesArray);
  //     setLoading(false);
  //   });

  //   return () => unsubscribe();
  // }, []);





  useEffect(() => {
  const database = getDatabase();
  const packagesRef = ref(database, "AgentPackages/international");

  const unsubscribe = onValue(packagesRef, (snapshot) => {
    const data = snapshot.val();
    const packagesArray = [];

    if (data) {
      Object.keys(data).forEach((country) => {
        Object.keys(data[country]).forEach((packageName) => {
          const pkg = data[country][packageName];

          if (pkg.type === "international") {
            // ✅ Extract numeric price from priceValues
            let firstPriceValue = "";
            if (pkg.priceValues) {
              if (Array.isArray(pkg.priceValues)) {
                firstPriceValue = pkg.priceValues[0] || "";
              } else if (typeof pkg.priceValues === "object") {
                const priceValuesArray = Object.values(pkg.priceValues);
                if (priceValuesArray.length > 0) {
                  firstPriceValue = priceValuesArray[0] || "";
                }
              } else if (typeof pkg.priceValues === "string") {
                firstPriceValue = pkg.priceValues;
              }
            }

            // ✅ Get only numbers from text like "5999 per person"
            const numericPrice = parseInt(
              String(firstPriceValue).replace(/\D/g, "")
            );

            // ✅ Calculate discounted price safely
            const discountedPrice = Math.max(0, numericPrice - 2000);

            packagesArray.push({
              id: `${country}-${packageName}`,
              ...pkg,
              originalPrice: numericPrice,
              discountedPrice,
            });
          }
        });
      });
    }

    setAllPackages(packagesArray);
    setFilteredPackages(packagesArray);
    setLoading(false);
  });

  return () => unsubscribe();
}, []);




  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredPackages(allPackages);
    } else {
      const filtered = allPackages.filter((pkg) => {
        const query = searchQuery.toLowerCase();
        return (
          (pkg.name && pkg.name.toLowerCase().includes(query)) ||
          (pkg.destination && pkg.destination.toLowerCase().includes(query)) ||
          (pkg.description && pkg.description.toLowerCase().includes(query)) ||
          (pkg.highlights && pkg.highlights.some(highlight => 
            highlight.toLowerCase().includes(query)
          ))
        );
      });
      setFilteredPackages(filtered);
      setVisibleCount(6);
    }
  }, [searchQuery, allPackages]);

  const loadMorePackages = () => {
    setVisibleCount((prev) => prev + 6);
  };

  const TourCard = ({ tour }) => (
    <div className="card">
      <div className="card-image-container">
        {tour.bestSelling && <span className="badge">Best Seller</span>}
        <img
          src={tour.images?.[0] || "https://via.placeholder.com/300x200?text=No+Image"}
          alt={tour.title}
          className="card-image"
        />
        <div className="location-tag">
          <FontAwesomeIcon icon={faMapMarkerAlt} /> {tour.destination}
        </div>
      </div>
      <div className="card-content">
        <div className="card-header">
          <h2 className="card-title">{tour.name}</h2>
          <div className="card-duration">
            <FontAwesomeIcon icon={faClock} /> {tour.duration}
          </div>
        </div>
        <div className="card-rating-price">
          <div className="card-rating">
            {[...Array(5)].map((_, i) => (
              <FontAwesomeIcon 
                key={i} 
                icon={i < Math.floor(tour.rating || 5) ? fasStar : farStar} 
                className={i < (tour.rating || 5) ? 'filled' : ''}
              />
            ))}
            <span>({tour.rating || 5}.0)</span>
          </div>
          <div className="card-price">
            <span className="from">From</span>
            <span className="amount">₹{tour.originalPrice?.toLocaleString() || tour.price?.toLocaleString() || "0"}</span>
            {/* <span className="per-person">per person</span> */}
          </div>
        </div>
        <div className="card-highlights">
          <h4>Highlights:</h4>
          <p>{tour.description?.split(" ").slice(0, 15).join(" ")}...</p>
        </div>
        <div className="card-footer">
          <button 
            className="view-btn" 
            onClick={() => setSelectedTour(tour)}
          >
            <FontAwesomeIcon icon={faEye} /> View Details
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Navbar />
      <style jsx>{`
        :root {
          --primary: #2563eb;
          --primary-dark: #1d4ed8;
          --secondary: #10b981;
          --accent: #f59e0b;
          --dark: #1e293b;
          --light: #f8fafc;
          --gray: #64748b;
          --light-gray: #e2e8f0;
          --white: #ffffff;
          --error: #e74c3c;
          --error-dark: #c0392b;
          --shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
          --shadow-lg: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          --border-radius: 12px;
          --border-radius-sm: 8px;
        }

        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
          font-family: 'Inter', sans-serif;
        }

        body {
          background-color: var(--light);
          color: var(--dark);
          line-height: 1.6;
        }

        /* Hero Section Styles */
        .hero-section {
          background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), 
                          url('https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80');
          background-size: cover;
          background-position: center;
          color: white;
          padding: 8rem 1rem;
          text-align: center;
          position: relative;
        }

        .hero-content {
          max-width: 800px;
          margin: 0 auto;
        }

        .hero-title {
          font-size: 3rem;
          font-weight: 800;
          margin-bottom: 1rem;
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
        }

        .hero-subtitle {
          font-size: 1.5rem;
          margin-bottom: 2rem;
          text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
        }

        .hero-search-box {
          display: flex;
          max-width: 600px;
          margin: 0 auto;
          border-radius: 50px;
          overflow: hidden;
          box-shadow: var(--shadow);
        }

        .hero-search-input {
          flex: 1;
          padding: 1rem 1.5rem;
          border: none;
          font-size: 1rem;
        }

        .hero-search-input::placeholder {
          color: #666;
        }

        .hero-search-button {
          padding: 0 2rem;
          background: var(--primary);
          color: white;
          border: none;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .hero-search-button:hover {
          background: var(--primary-dark);
        }

        .container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 2rem 1rem;
        }

        /* Cards Container */
        .cards-container {
          width: 100%;
        }

        .cards {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 2rem;
          margin-bottom: 2rem;
        }

        /* Tour Card */
        .card {
          background: var(--white);
          border-radius: var(--border-radius);
          overflow: hidden;
          box-shadow: var(--shadow);
          transition: var(--transition);
          position: relative;
        }

        .card:hover {
          transform: translateY(-5px);
          box-shadow: var(--shadow-lg);
        }

        .card-image-container {
          position: relative;
          height: 200px;
          overflow: hidden;
        }

        .card-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: var(--transition);
        }

        .card:hover .card-image {
          transform: scale(1.05);
        }

        .badge {
          position: absolute;
          top: 1rem;
          left: 1rem;
          background: var(--accent);
          color: var(--white);
          padding: 0.3rem 0.8rem;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
          z-index: 1;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .location-tag {
          position: absolute;
          bottom: 1rem;
          left: 1rem;
          background: rgba(0, 0, 0, 0.7);
          color: var(--white);
          padding: 0.5rem 1rem;
          border-radius: 20px;
          font-size: 0.8rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          z-index: 1;
          backdrop-filter: blur(2px);
        }

        .card-content {
          padding: 1.5rem;
        }

        .card-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 1rem;
          gap: 1rem;
        }

        .card-title {
          font-size: 1.2rem;
          font-weight: 700;
          color: var(--dark);
          margin-bottom: 0.5rem;
          flex: 1;
          line-height: 1.4;
        }

        .card-duration {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.9rem;
          color: var(--gray);
          white-space: nowrap;
        }

        .card-rating-price {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1.5rem;
          gap: 1rem;
        }

        .card-rating {
          display: flex;
          align-items: center;
          gap: 0.3rem;
        }

        .card-rating .filled {
          color: var(--accent);
        }

        .card-price {
          text-align: right;
        }

        .from {
          display: block;
          font-size: 0.7rem;
          color: var(--gray);
          margin-bottom: 0.2rem;
        }

        .amount {
          font-size: 1.3rem;
          font-weight: 700;
          color: var(--primary);
        }

        .per-person {
          display: block;
          font-size: 0.7rem;
          color: var(--gray);
          margin-top: 0.2rem;
        }

        .card-highlights {
          margin-bottom: 1.5rem;
        }

        .card-highlights h4 {
          font-size: 1rem;
          font-weight: 600;
          color: var(--dark);
          margin-bottom: 0.8rem;
        }

        .card-highlights p {
          font-size: 0.9rem;
          color: var(--gray);
          line-height: 1.5;
        }

        .card-footer {
          display: flex;
          gap: 1rem;
        }

        .view-btn {
          flex: 1;
          padding: 0.7rem;
          border-radius: var(--border-radius-sm);
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          font-size: 0.9rem;
          background: var(--light-gray);
          color: var(--dark);
          border: none;
        }

        .view-btn:hover {
          background: #d1d5db;
        }

        /* Load Button */
        .load-more-btn {
          padding: 0.8rem 1.5rem;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          border: none;
          background: var(--primary);
          color: var(--white);
          margin: 2rem auto;
        }

        .load-more-btn:hover {
          background: var(--primary-dark);
          transform: translateY(-2px);
          box-shadow: var(--shadow);
        }

        /* Loading Spinner */
        .loading-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 300px;
        }

        .spinner {
          width: 50px;
          height: 50px;
          border: 5px solid rgba(0, 0, 0, 0.1);
          border-radius: 50%;
          border-top-color: var(--primary);
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        /* No Results */
        .no-results {
          text-align: center;
          padding: 3rem;
          background: var(--white);
          border-radius: var(--border-radius);
          box-shadow: var(--shadow);
        }

        .no-results h3 {
          color: var(--dark);
          margin-bottom: 0.5rem;
        }

        .no-results p {
          color: var(--gray);
          margin-bottom: 1rem;
        }

        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 2rem;
          overflow-y: auto;
        }

        .modal-container {
          background: var(--white);
          border-radius: var(--border-radius);
          width: 100%;
          max-width: 1000px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
          position: relative;
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .modal-close-btn {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: none;
          border: none;
          font-size: 1.5rem;
          color: var(--gray);
          cursor: pointer;
          transition: var(--transition);
          z-index: 10;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
        }

        .modal-close-btn:hover {
          color: var(--primary);
          background: var(--light-gray);
        }

        .modal-header {
          padding: 2rem 2rem 1rem;
          border-bottom: 1px solid var(--light-gray);
        }

        .modal-header h2 {
          color: var(--dark);
          margin-bottom: 0.5rem;
          font-weight: 700;
        }

        .modal-header p {
          color: var(--gray);
        }

        .modal-subheader {
          display: flex;
          gap: 1.5rem;
          flex-wrap: wrap;
          color: var(--gray);
          font-size: 0.9rem;
          margin-top: 0.5rem;
        }

        .modal-subheader span {
          display: flex;
          align-items: center;
          gap: 0.3rem;
        }

        .modal-image-gallery {
          display: grid;
          grid-template-columns: 1fr;
          gap: 1rem;
          padding: 0 2rem;
          margin-top: 1rem;
        }

        .main-image {
          width: 100%;
          height: 400px;
          border-radius: var(--border-radius-sm);
          overflow: hidden;
        }

        .main-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .thumbnail-container {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 1rem;
        }

        .thumbnail {
          height: 80px;
          border-radius: var(--border-radius-sm);
          overflow: hidden;
          cursor: pointer;
          transition: var(--transition);
        }

        .thumbnail:hover {
          transform: translateY(-3px);
          box-shadow: var(--shadow);
        }

        .thumbnail img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .modal-content {
          display: grid;
          grid-template-columns: 1fr 300px;
          gap: 2rem;
          padding: 2rem;
        }

        .modal-price-section {
          position: sticky;
          top: 1rem;
          height: fit-content;
        }

        .price-box {
          background: var(--light);
          border-radius: var(--border-radius-sm);
          padding: 1.5rem;
          text-align: center;
          box-shadow: var(--shadow);
        }

        .price-label {
          display: block;
          font-size: 0.9rem;
          color: var(--gray);
          margin-bottom: 0.5rem;
        }

        .price-amount {
          font-size: 2rem;
          font-weight: 700;
          color: var(--primary);
          line-height: 1;
          display: block;
        }

        .price-per {
          display: block;
          font-size: 0.8rem;
          color: var(--gray);
          margin-bottom: 1.5rem;
        }

        .pdf-download-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 10px 15px;
          margin-top: 15px;
          background-color: var(--error);
          color: white;
          border: none;
          border-radius: var(--border-radius-sm);
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          width: 100%;
        }

        .pdf-download-btn:hover {
          background-color: var(--error-dark);
          transform: translateY(-2px);
          box-shadow: var(--shadow);
        }

        .modal-details-section h3 {
          color: var(--dark);
          margin: 1.5rem 0 1rem;
          font-size: 1.2rem;
          font-weight: 600;
        }

        .highlights-list, .inclusions-list, .exclusions-list {
          list-style: none;
          margin-bottom: 1.5rem;
        }

        .highlights-list li, .inclusions-list li, .exclusions-list li {
          margin-bottom: 0.5rem;
          display: flex;
          align-items: flex-start;
          gap: 0.5rem;
          line-height: 1.5;
        }

        .highlight-icon {
          color: var(--accent);
          margin-top: 0.2rem;
          flex-shrink: 0;
        }

        .inclusion-icon {
          color: var(--secondary);
          margin-top: 0.2rem;
          flex-shrink: 0;
        }

        .exclusion-icon {
          color: var(--error);
          margin-top: 0.2rem;
          flex-shrink: 0;
        }

        .day-plan {
          margin-bottom: 1.5rem;
        }

        .day-plan h4 {
          color: var(--dark);
          margin-bottom: 0.5rem;
          font-weight: 600;
        }

        .day-plan p {
          color: var(--gray);
          line-height: 1.6;
        }

        .terms {
          font-size: 0.9rem;
          color: var(--gray);
          line-height: 1.6;
        }

        /* Responsive Styles */
        @media (max-width: 900px) {
          .modal-content {
            grid-template-columns: 1fr;
          }
          
          .modal-price-section {
            position: static;
          }
        }

        @media (max-width: 768px) {
          .hero-title {
            font-size: 2.5rem;
          }
          
          .hero-subtitle {
            font-size: 1.2rem;
          }
          
          .cards {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 600px) {
          .hero-section {
            padding: 6rem 1rem;
          }
          
          .hero-title {
            font-size: 2rem;
          }
          
          .hero-subtitle {
            font-size: 1rem;
          }
          
          .hero-search-box {
            flex-direction: column;
            border-radius: var(--border-radius);
          }
          
          .hero-search-input {
            border-radius: var(--border-radius-sm) var(--border-radius-sm) 0 0;
          }
          
          .hero-search-button {
            border-radius: 0 0 var(--border-radius-sm) var(--border-radius-sm);
            padding: 0.8rem;
          }
          
          .modal-overlay {
            padding: 1rem;
          }
          
          .modal-header, .modal-image-gallery, .modal-content {
            padding: 1rem;
          }
          
          .main-image {
            height: 250px;
          }
          
          .thumbnail-container {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 480px) {
          .hero-title {
            font-size: 1.8rem;
          }
        }
      `}</style>

      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">Explore World's Hidden Gems</h1>
          <p className="hero-subtitle">
            Discover handcrafted international tour packages to the world's most enchanting 
            destinations, with exclusive discounts and personalized experiences
          </p>
          <div className="hero-search-box">
            <input
              type="text"
              className="hero-search-input"
              placeholder="Search packages by name or destination..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className="hero-search-button">
              <FontAwesomeIcon icon={faSearch} /> Search
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container">
        <div className="cards-container">
          {loading ? (
           <div>
          <style>{`
         .loading-container {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: linear-gradient(135deg, #7d0000ff 0%, #ab0404ff 100%);
          color: #fff;
          z-index: 9999;
          flex-direction: column;
         }

        .loader {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 16px;
         }

        .loader-spinner {
          width: 80px;
          height: 80px;
          border: 8px solid rgba(255, 255, 255, 0.2);
          border-top: 8px solid #fff;
          border-radius: 50%;
          animation: spin 1.2s linear infinite;
         }

        .loader-spinner-inner {
          width: 40px;
          height: 40px;
          border: 4px solid rgba(255, 255, 255, 0.2);
          border-top: 4px solid #ffeb3b;
          border-radius: 50%;
          margin: auto;
          margin-top: 14px;
          animation: spin-reverse 1.5s linear infinite;
         }

        .loader-text {
          font-size: 1.4rem;
          font-weight: bold;
          letter-spacing: 1px;
          margin-top: 10px;
         }

        .loader-dots {
          display: flex;
          gap: 6px;
          margin-top: 5px;
         }

        .dot {
          width: 10px;
          height: 10px;
          background: #fff;
          border-radius: 50%;
          animation: bounce 1.2s infinite ease-in-out;
         }

        .dot:nth-child(1) {
          animation-delay: 0s;
         }

        .dot:nth-child(2) {
          animation-delay: 0.2s;
        }

        .dot:nth-child(3) {
          animation-delay: 0.4s;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes spin-reverse {
          0% { transform: rotate(360deg); }
          100% { transform: rotate(0deg); }
        }

        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0.8);
            opacity: 0.6;
          }
          40% {
            transform: scale(1.2);
            opacity: 1;
          }
        }
      `}</style>

      <div className="loading-container">
        <div className="loader">
          <div className="loader-spinner">
            <div className="loader-spinner-inner"></div>
          </div>
          <div className="loader-text">Loading Packages</div>
          <div className="loader-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
    </div>
          ) : filteredPackages.length > 0 ? (
            <>
              <div className="cards">
                {filteredPackages.slice(0, visibleCount).map((tour) => (
                  <TourCard key={tour.id} tour={tour} />
                ))}
              </div>

              {visibleCount < filteredPackages.length && (
                <button
                  className="load-more-btn"
                  onClick={loadMorePackages}
                >
                  Load More Packages
                </button>
              )}
            </>
          ) : (
            <div className="no-results">
              <h3>No packages found matching your search</h3>
              <p>Try adjusting your search query</p>
            </div>
          )}
        </div>
      </div>
      
      {selectedTour && (
        <TourDetailsModal 
          tour={selectedTour} 
          onClose={() => setSelectedTour(null)} 
        />
      )}
      
      <Footer />
    </>
  );
}